import { z } from "zod";
import {
  BillingBasis,
  Country,
  Currency,
  Locale,
  StringNE,
} from "./common.schema.js";

export const VisionEndpoint = z.enum([
  "lcbDefault",
  "lcbHillington",
  "lcbGroup3",
  "ehdDefault",
  "rarterGroup1",
]);

export const ExternalEndpoint = z.discriminatedUnion("kind", [
  z.object({
    kind: z.literal("vision"),
    value: VisionEndpoint,
  }),
  z.object({
    kind: z.literal("amsterdam"),
  }),
  z.object({
    kind: z.literal("lawDistribution"),
  }),
]);
export type ExternalEndpoint = z.infer<typeof ExternalEndpoint>;

export const WarehouseGroup = z.enum(["lcb", "ehd", "awc"]);
export type WarehouseGroup = z.infer<typeof WarehouseGroup>;

export const StorageLocation = z.object({
  locationName: StringNE,
  ownerOrganisationId: z.string().nullable(),
  ferovinumAccountCode: z.string().nullable(),
  siteCode: z.string().nullable(),
  addressLine1: z.string().nullable(),
  addressLine2: z.string().nullable(),
  town: z.string().nullable(),
  postCode: z.string().nullable(),
  country: Country.nullable(),
  billingBasis: BillingBasis,
  rotationNumberRequired: z.boolean(),
  locale: Locale,
  publiclyAvailable: z.boolean(),
  currency: Currency,
  hasD2cFulfilment: z.boolean(),
  endpoint: ExternalEndpoint.nullable(),
  ownerId: z.string().nullable(),
  warehouseGroup: WarehouseGroup.nullable(),
});
export type StorageLocation = z.infer<typeof StorageLocation>;
